import { render, staticRenderFns } from "./ModalEtapas.vue?vue&type=template&id=0b0b4438&"
import script from "./ModalEtapas.vue?vue&type=script&lang=js&"
export * from "./ModalEtapas.vue?vue&type=script&lang=js&"
import style0 from "./ModalEtapas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports